"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIT_MAP = void 0;
exports.UNIT_MAP = {
    'ft3/m': 'ft3m',
    'L/m': 'Lmin',
    'L/s': 'Lsec',
    'L/hr': 'Lhr',
    'kg/cm2': 'kgcm2',
    ft: 'ftH2O',
    m: 'mH2O',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5pdE1hcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy91bml0TWFwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsUUFBUSxHQUEyQjtJQUM1QyxPQUFPLEVBQUUsTUFBTTtJQUNmLEtBQUssRUFBRSxNQUFNO0lBQ2IsS0FBSyxFQUFFLE1BQU07SUFDYixNQUFNLEVBQUUsS0FBSztJQUNiLFFBQVEsRUFBRSxPQUFPO0lBQ2pCLEVBQUUsRUFBRSxPQUFPO0lBQ1gsQ0FBQyxFQUFFLE1BQU07Q0FDWixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IFVOSVRfTUFQOiBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+ID0ge1xuICAgICdmdDMvbSc6ICdmdDNtJyxcbiAgICAnTC9tJzogJ0xtaW4nLFxuICAgICdML3MnOiAnTHNlYycsXG4gICAgJ0wvaHInOiAnTGhyJyxcbiAgICAna2cvY20yJzogJ2tnY20yJyxcbiAgICBmdDogJ2Z0SDJPJyxcbiAgICBtOiAnbUgyTycsXG59O1xuIl19